/**
@ngdoc directive
@name getListingTiles

@param {Object} tilesData prepared tiles data exposed by the directive
@param {string} url url

@usage

@description
Termporary directive (longer term should be probably controller) retrieving and preparing backend json data for listing tile components.
The logic to be moved to xmsListing at the end of all tiles rewrite process.
*/


(function() {
    'use strict';

    const getTilesData = function(ajaxCall, mapTilesJsonData, $templateCache, xmsNotificationFactory) {
        return {
            restrict: "EA",
            scope: true,
            bindToController: {
                /*  '@' Text binding  '=' Two-way binding  '&' Method binding  '<' One-way binding  */
                url: '@',
                numberOfTiles: '@',
                // Removed below. The developer broke this in X3-11739 by turning it to a string resulting in 36 calls in listingTile.js
                //tilesData: '@',
                listingModel: '='
            },
            template: $templateCache.get('components/listing/getTilesData.html'),
            controllerAs: 'ctrl',
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                const _this = this;

                this.$onInit = function () {

                    if(_this.url){

                        const emptyObject = {};
                        let emptyList = [];
                        let numberOfTiles = _this.numberOfTiles;
                        for (numberOfTiles; numberOfTiles > 0; numberOfTiles--){
                            emptyList.push(emptyObject);
                        }
                        _this.tilesData = emptyList;

                        ajaxCall.getData(_this.url).then(
                            function(result) {
                                // emptying the array of tile data, because the result might have different amount of tiles than expected
                                _this.tilesData = [];
                                //Passing all the data including labels
                                const mappedTiles = mapTilesJsonData.mapTilesData(result.data);
                                // prepare raw tiles data and merge into ctrl tilesData, so they are not overriden even if multiple <get-tiles-data> is placed in the listing
                                _this.tilesData = angular.merge( _this.tilesData, mappedTiles);
                            },
                            function(result) { // error handling
                                console.log(result);
                                _this.listingModel.isError = true;
                                const errorMessage = "Error: " + result.status + ' -  failed to load tile(s)';
                                _this.listingModel.errorMsg = errorMessage;
                                xmsNotificationFactory.add('closeAndTableRefreshMsg', 'danger', errorMessage, 5);
                                _this.tilesData.error = errorMessage;
                            }
                        );
                    }
                }
            }]
        };
    };
    getTilesData.$inject = ['ajaxCall', 'mapTilesJsonData', '$templateCache', 'xmsNotificationFactory'];
    angular.module('app').directive('getTilesData', getTilesData);


}());